import { useTrans } from "@/utils/useTrans";
import React from "react";
import {
  Sheet,
  SheetClose,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from "@/v2-components/ui/sheet";
import CrossIcon from "@/v2-components/core/icon/cross-icon";
import { cn } from "@/libs/utils";

export const BottomUpSheet = ({
  open,
  children,
  onOpenChange,
  title,
  className,
}: React.PropsWithChildren<{
  title?: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  className?: string;
}>) => {
  const { t } = useTrans(["tactsuit"]);

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        className="flex max-h-[calc(90dvh)] flex-col"
        side={"bottom"}
      >
        <SheetHeader className="items-center justify-between">
          <SheetTitle className={cn("text-2xl", className)}>
            {title || t("Compare")}
          </SheetTitle>
          <SheetClose className="focus:outline-none">
            <CrossIcon />
            <span className="sr-only">Close</span>
          </SheetClose>
        </SheetHeader>
        <div className="flex-1 overflow-auto">{children}</div>
      </SheetContent>
    </Sheet>
  );
};
